export enum EstadoTypeEnum {
    ACTIVO = '0',
    PROXIMO = '1',
    INACTIVO = '2',
}